import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_dropdown = _resolveComponent("input-dropdown")!

  return (_ctx.dataItems.length)
    ? (_openBlock(), _createBlock(_component_input_dropdown, {
        key: 0,
        id: _ctx.id,
        modelValue: _ctx.selectedId,
        "data-items": _ctx.dataItems,
        "value-field": "id",
        "text-field": "name",
        placeholder: _ctx.localize('chooseDeliveryAddress'),
        width: _ctx.width,
        "onUpdate:modelValue": _ctx.onChange
      }, null, 8, ["id", "modelValue", "data-items", "placeholder", "width", "onUpdate:modelValue"]))
    : _createCommentVNode("", true)
}